import { render, staticRenderFns } from "./FormJobSalary.vue?vue&type=template&id=464cbbd2&scoped=true&"
import script from "./FormJobSalary.vue?vue&type=script&lang=js&"
export * from "./FormJobSalary.vue?vue&type=script&lang=js&"
import style0 from "./FormJobSalary.vue?vue&type=style&index=0&id=464cbbd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464cbbd2",
  null
  
)

export default component.exports